import { exposedConfig } from '../../../../generated-config';
import { useT } from '../../../../i18n/I18nProvider';
import { PageHeading } from '../../../../ui/atoms/PageHeading';
import { PublicShell } from '../../layouts/PublicShell';

export function AccessibilityPage() {
  const { t } = useT();
  const email = exposedConfig.support.email;

  return (
    <PublicShell>
      <article className="card bg-base-100 shadow-xl w-full max-w-2xl">
        <div className="card-body gap-4">
          <PageHeading className="card-title">
            {t('public.accessibility:title')}
          </PageHeading>
          <section className="space-y-2">
            <h2 className="text-xl font-semibold">
              {t('public.accessibility:commitment.title')}
            </h2>
            <p>{t('public.accessibility:commitment.body')}</p>
          </section>
          <section className="space-y-2">
            <h2 className="text-xl font-semibold">
              {t('public.accessibility:standard.title')}
            </h2>
            <p>{t('public.accessibility:standard.body')}</p>
          </section>
          <section className="space-y-2">
            <h2 className="text-xl font-semibold">
              {t('public.accessibility:gaps.title')}
            </h2>
            <p>{t('public.accessibility:gaps.body')}</p>
            <p>{t('public.accessibility:gaps.agenda')}</p>
          </section>
          <section className="space-y-2">
            <h2 className="text-xl font-semibold">
              {t('public.accessibility:contact.title')}
            </h2>
            <p>
              {t('public.accessibility:contact.body')}{' '}
              <a className="link" href={`mailto:${email}`}>
                {email}
              </a>
            </p>
          </section>
          <p className="text-sm text-base-content/70">
            {t('public.accessibility:lastReviewed')}
          </p>
        </div>
      </article>
    </PublicShell>
  );
}
